import { SellingPlanGroupApiResponse } from "@smartrr/shared/entities/SellingPlanGroup";
import { hasProductsSelected } from "./hasProductsSelected";

export const findNextSellingPlanGroupForSetup = (
  sellingPlanGroups: SellingPlanGroupApiResponse[],
  deletedPlanGroupId: string | null | undefined
): SellingPlanGroupApiResponse | undefined => {
  // Add-on and trending-list groups are not eligible to be selected within setup
  const selectableSellingPlanGroups = sellingPlanGroups.filter(
    group => group.id !== deletedPlanGroupId && !group.isAddon && !group.isTrendingList
  );

  const nextSellingPlanGroup = selectableSellingPlanGroups.find(group => hasProductsSelected(group));

  return nextSellingPlanGroup ?? selectableSellingPlanGroups[0];
};
